import React, { ReactEventHandler, useEffect, useRef, useState } from "react";
import CardContent from "@mui/material/CardContent";
import { Autocomplete, Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import Map from "./MapBase";
import { useNavigate } from "react-router-dom";
import { CardSmallMapContainer, MapSmallCardContainer } from "../assets/style";
import MapTextCard from './MapTextCard';
import MapsForCard from "./MapsForCard";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Permissions } from "../utils/Permissions";
import { useSelector } from "react-redux";
import { selectPermissions } from "../features/auth/authSlice";
import dayjs from "dayjs";

function MapCard(props: {
    selectPosition?: any,
    onAddLocation?: (newLocation: any) => void,
    onEditLocation?: (location: any) => void,
    setAddPosition?: (cancel: boolean) => void,
    isInputMode?: boolean,
    projectId?: string,
    project?: any
}) {
    const { selectPosition, onAddLocation, onEditLocation, setAddPosition, isInputMode, projectId, project } = props;
    const [inputMode, setInputMode] = useState(isInputMode);
    const [locationId, setLocationId] = useState(`${selectPosition?.code || ""}`);
    const locationNameRef = useRef(`${selectPosition?.name || ""}`)
    const [locationDetail, setLocationDetail] = useState(`${selectPosition?.nameOfConfinedSpace || ""}`);
    const [coordinates, setCoordinates] = useState(`${selectPosition?.lat || 22.3780027}, ${selectPosition?.lng || 114.1830961}`);
    const [lat, lng] = coordinates.split(", ");
    const [searchResults, setSearchResults] = useState<any>([]);
    const { t, i18n } = useTranslation();
    const permissions = useSelector(selectPermissions)
    const previousInputTime = useRef(dayjs())

    const navigate = useNavigate()
    // console.log("selectPosition, ", selectPosition)
    function getCoordinates(loc: string) {
        setCoordinates(loc);
    }

    const handleCoordinates = (loc: any) => {
        const [lat, lng] = loc.split(", ");
        if (!isNaN(parseFloat(lat)) && !isNaN(parseFloat(lng))) {
            setCoordinates(loc)
        } else if (!isNaN(parseFloat(lat))) {
            loc = `${lat}, 114`
            setCoordinates(loc)
        } else if (!isNaN(parseFloat(lng))) {
            loc = `22, ${lng}`
            setCoordinates(loc)
        }
    };

    const handleApply = () => {
        const newLocation = {
            projectId: projectId,
            code: locationId,
            lat: parseFloat(lat),
            lng: parseFloat(lng),
            name: locationNameRef.current,
            nameOfConfinedSpace: locationDetail,

        };
        onAddLocation && onAddLocation(newLocation);
        setInputMode(false);
    };

    const handleEdit = () => {
        const updatedLocationDetail = {
            ...selectPosition,
            projectId: projectId,
            code: locationId,
            lat: parseFloat(lat),
            lng: parseFloat(lng),
            name: locationNameRef.current,
            nameOfConfinedSpace: locationDetail,
        }
        onEditLocation && onEditLocation(updatedLocationDetail)
        setInputMode(false);
    };

    const inputUpdateTime = 500
    const updateLocationName = (locationName: string) => {
        locationNameRef.current = locationName
        previousInputTime.current = dayjs().add(inputUpdateTime, "millisecond")
        setTimeout(() => {
            const now = dayjs()
            if (now.isAfter(previousInputTime.current)) {
                handleSearch(locationNameRef.current)
            }
        }, inputUpdateTime)
    }

    const handleCancel = () => {
        setInputMode(false);
        setAddPosition && setAddPosition(false)
    };

    const handleEditButtonClick = () => {
        setInputMode(true);
    };

    const handleSearch = async (locationName: string) => {
        try {
            const response = await axios.get(`https://nominatim.openstreetmap.org/search?q=${locationName}&format=jsonv2&limit=10&accept-language=zh-Hant`);
            setSearchResults(response.data.filter((result: any) => result.display_name.includes("香港")));
        } catch (error) {
            console.error('Error searching OpenStreetMap:', error);
        }
    };
    const onAutoCompleteChange: ReactEventHandler = (event: any) => {
        // handleSearch(event?.target.value)
        const selectedResult = searchResults.find((result: any) => result.display_name === event.target.innerText);
        handleCoordinates(`${selectedResult?.lat}, ${selectedResult?.lon}`);
        setLocationDetail(selectedResult?.name)
    };

    return (

        <>
            {!inputMode ?
                // <MapTextCard selectPosition={selectPosition} onEditLocation={onEditLocation} length={length} />
                //text card
                <MapSmallCardContainer>
                    <CardContent style={{ height: 350, width: "100%", position: 'relative' }}>
                        <CardSmallMapContainer>
                            <Map zoom={15} coordinates={coordinates} getCoordinates={getCoordinates} name="" isInput={false} />
                        </CardSmallMapContainer>
                        <br />
                        <Typography variant="body2" color="text.secondary" fontSize={16}>
                            {t("Location No.:")} {selectPosition?.code}<br />
                            {t("Location Address: ")} {selectPosition?.name}<br />
                            {t("Name Of Confined Space:")} {selectPosition?.nameOfConfinedSpace}<br />
                            {t("Coordinates: ")} {selectPosition?.lat}, {selectPosition?.lng}
                        </Typography>

                        <br />
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {/* <Button variant='contained' style={{ backgroundColor: '#407cb3' }} onClick={() => { navigate('/work-schedule', { state: projectId }) }}>Schedule</Button> */}
                            {
                                permissions.includes(Permissions.EntryView)
                                && <Button variant='contained' style={{ backgroundColor: '#407cb3' }} onClick={() => { navigate('/work-schedule', { state: { project: project, position: selectPosition } }) }}>{t("Schedule")}</Button>
                            }
                            {
                                permissions.includes(Permissions.LocationEdit)
                                && <Button variant='contained' style={{ backgroundColor: '#407cb3' }} onClick={handleEditButtonClick} >{t("Edit")}</Button>
                            }
                        </div>
                    </CardContent>
                </MapSmallCardContainer>
                :
                <Box>
                    <MapSmallCardContainer style={{ height: "650px" }}>
                        <CardContent style={{ height: 350, width: "100%", position: 'relative' }}>
                            <CardSmallMapContainer>
                                <Map zoom={15} coordinates={coordinates} getCoordinates={getCoordinates} isInput={true} />
                            </CardSmallMapContainer>
                            <br />
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: "100%" }} >
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ flex: '0 0 100px' }}>{t("Location No.:")}</Box>
                                    <TextField size="small" InputProps={{ sx: { borderRadius: 3, width: "100%" } }} fullWidth
                                        value={locationId}
                                        onChange={(e) => setLocationId(e.target.value)}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ flex: '0 0 100px' }}>{t("Location Address: ")}</Box>
                                    <Autocomplete
                                        options={searchResults.map((result: any) => result.display_name)}
                                        onInputChange={(event, newInputValue) => updateLocationName(newInputValue)}
                                        filterOptions={(_, __) => searchResults.map((result: any) => result.display_name)}
                                        onChange={onAutoCompleteChange}
                                        renderInput={(params) => <TextField {...params} />}
                                        fullWidth
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    {i18n.language == "en" && <Box sx={{ flex: '0 0 100px' }}>
                                        Name of<br />Confined<br />Space:
                                    </Box>}
                                    {i18n.language == "zh" && <Box sx={{ flex: '0 0 100px' }}>
                                        密閉空間<br />地點:
                                    </Box>}
                                    <TextField margin="none" InputProps={{ sx: { borderRadius: 3, height: 70, width: "100%" } }} fullWidth
                                        value={locationDetail}
                                        onChange={(e) => setLocationDetail(e.target.value)}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ flex: '0 0 100px' }}>{t("Coordinates: ")}</Box>
                                    <TextField size="small" InputProps={{ sx: { borderRadius: 3, width: "100%" } }} fullWidth
                                        value={coordinates}
                                        onChange={(e) => handleCoordinates(e.target.value)}
                                    />
                                </Box>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    {onEditLocation != null ? <Button variant='contained' style={{ backgroundColor: '#407cb3' }} onClick={handleEdit}>{t("Apply")}</Button>
                                        : <Button variant='contained' style={{ backgroundColor: '#407cb3' }} onClick={handleApply}>{t("Apply")}</Button>
                                    }
                                    <Button variant='contained' style={{ backgroundColor: '#a6abb3' }} onClick={handleCancel}>{t("Cancel")}</Button>
                                </div>
                            </Box>
                            <br />
                        </CardContent>
                    </MapSmallCardContainer>
                </Box>
            }
        </>
    );
}

export default MapCard;